import React from "react";
import { AccordionContextType } from "./types";

export const AccordionContext = React.createContext<AccordionContextType>({
  expanded: [],
  toggle: (id) => {},
});
